"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyRange = void 0;
var react_1 = __importStar(require("react"));
var react_date_range_1 = require("react-date-range");
var classnames_1 = __importDefault(require("classnames"));
var locale_1 = require("react-date-range/dist/locale");
var dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/nl");
var formTypes_1 = require("../../../types/formTypes");
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
var InputDayRange_styles_1 = __importDefault(require("./InputDayRange.styles"));
var schoolyear_1 = require("../../../types/schoolyear");
require("react-date-range/dist/styles.css"); // main css file
require("react-date-range/dist/theme/default.css");
exports.emptyRange = {
    id: 0,
    visible: false,
    startDate: undefined,
    endDate: undefined,
    state: formTypes_1.NEW,
};
var InputDayRange = function (_a) {
    var label = _a.label, id = _a.id, _b = _a.value, value = _b === void 0 ? [exports.emptyRange] : _b, valueChanged = _a.valueChanged, error = _a.error;
    var _c = react_1.useState(value), ranges = _c[0], setRanges = _c[1];
    var _d = react_1.useState(0), globalRangeID = _d[0], setGlobalRangeID = _d[1];
    var addRange = function (e) {
        e.preventDefault();
        setRanges(function (prevRanges) { return __spreadArrays(prevRanges, [__assign(__assign({}, exports.emptyRange), { id: globalRangeID })]); });
        setGlobalRangeID(globalRangeID + 1);
    };
    var removeRange = function (index) {
        setRanges(function (prevRanges) {
            var newRanges = __spreadArrays(prevRanges);
            newRanges[index].state = formTypes_1.DELETED;
            return newRanges;
        });
    };
    var updateRange = function (index, newValue) {
        setRanges(function (prevRanges) {
            var newRanges = __spreadArrays(prevRanges);
            var oldRangeValue = newRanges[index];
            newRanges[index] = __assign(__assign({}, oldRangeValue), newValue);
            // if (Object.prototype.hasOwnProperty.call(newRanges[index], 'visible')) {
            //     newRanges[index].visible = !newRanges[index].visible;
            // }
            return newRanges;
        });
    };
    var toggleDatepicker = function (e, index) {
        e.preventDefault();
        setRanges(function (prevDays) {
            var newDays = __spreadArrays(prevDays);
            newDays[index].visible = !newDays[index].visible;
            return newDays;
        });
    };
    react_1.useEffect(function () {
        var sortedRanges = ranges;
        sortedRanges.sort(function (a, b) { return (a.id > b.id ? -1 : 1); });
        if (sortedRanges.length) {
            setGlobalRangeID(sortedRanges[0].id + 1);
        }
    }, []);
    react_1.useEffect(function () {
        valueChanged(id, ranges);
    }, [ranges]);
    react_1.useEffect(function () {
        setRanges(value);
    }, [value]);
    var onDatePickerChange = function (e, index) {
        updateRange(index, e.range1);
    };
    var rangeHasValues = function (range) { return range.startDate !== undefined && range.endDate !== undefined; };
    var checkIfRangeIsValid = function (range) {
        if (range.startDate === undefined && range.endDate === undefined) {
            return {
                startDate: dayjs_1.default().toDate(),
                endDate: dayjs_1.default().add(2, 'day').toDate(),
            };
        }
        return range;
    };
    var formatToHumanDate = function (date) {
        return date === undefined ? 'dd-mm-yyyy' : dayjs_1.default(date).locale('nl').format('DD MMMM YYYY');
    };
    console.log(schoolyear_1.SCHOOLYEAR_START);
    console.log(schoolyear_1.SCHOOLYEAR_END);
    return (react_1.default.createElement(InputDayRange_styles_1.default, null,
        react_1.default.createElement("p", { className: "label" }, label),
        react_1.default.createElement("div", { className: "ranges" }, ranges
            // .filter((item) => item.state !== DELETED)
            .map(function (range, index) { return (react_1.default.createElement("div", { key: range.id, className: classnames_1.default('range', range.state === formTypes_1.DELETED && 'hidden') },
            react_1.default.createElement("button", { className: "datePicker", onClick: function (e) { return toggleDatepicker(e, index); } },
                react_1.default.createElement("svg", { className: "icon icon--calendar", "aria-hidden": "true" },
                    react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#calendar" })),
                react_1.default.createElement("span", null,
                    formatToHumanDate(range.startDate),
                    " \u2014 ",
                    formatToHumanDate(range.endDate))),
            range.visible && (react_1.default.createElement(react_date_range_1.DateRange, { locale: locale_1.nl, minDate: schoolyear_1.SCHOOLYEAR_START, maxDate: schoolyear_1.SCHOOLYEAR_END, ranges: [checkIfRangeIsValid(range)], onChange: function (e) { return onDatePickerChange(e, index); } })),
            ranges.length > 0 && rangeHasValues(range) && (react_1.default.createElement("button", { type: "button", onClick: function () { return removeRange(index); }, className: "remove-range" },
                react_1.default.createElement("svg", { className: "icon icon-min", "aria-hidden": "true" },
                    react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#cross" })))))); })),
        react_1.default.createElement("button", { type: "button", onClick: addRange, className: "add-range" },
            "Nog een datum range toevoegen",
            react_1.default.createElement("svg", { className: "icon icon-arrow", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#plus" }))),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputDayRange;
